import React from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CORES_STATUS = {
  enviado: "info",
  em_analise: "warning",
  analise_finalizada: "success",
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation("reportesFarmaco");

  return (
    <Badge bg={CORES_STATUS[status] || "secondary"}>
      {t(`reportesFarmaco:status.${status}`, { defaultValue: status })}
    </Badge>
  );
};

export default StatusBadge;
